module.exports = __webpack_public_path__ + "static/media/search-sidebar.ccb18930.svg";